export default "__VITE_ASSET__2oyEyANL__"